import React, { useEffect, useState } from 'react';
import EssenceAnimatedCheckbox from '../../../../components/essence/checkbox/animated-checkbox';
import EssenceButton from '../../../../components/essence/button/button';
import Header from '../../../../shared/components/header/page';
import Content from '../../../../shared/components/content/page';
import { useNavigate, useParams } from 'react-router-dom';
import { useCircleMutations } from '../../../../shared/tanstack/circle/mutations';
import { useMutation, useQuery } from '@tanstack/react-query';
import { UpdateCircleRequest } from '../../../../shared/tanstack/circle/api';
import { useCircleQueries } from '../../../../shared/tanstack/circle/queries';
import { InvalidCircleIdError } from '../../../../shared/models/errors/invalid-circle-id-error';

interface Interest {
	displayName: string;
	value: string;
	disabled: boolean;
	isChecked: boolean;
}

export default function CircleModules() {
	const navigate = useNavigate();
	const { updateCircleMutation } = useCircleMutations();
	const { mutate: updateCircle, isSuccess } = useMutation(updateCircleMutation);
	const [interests, setInterests] = useState<Interest[]>([]);
	const { id: circleId } = useParams();
	const { circleQuery } = useCircleQueries();
	if (!circleId) {
		throw new InvalidCircleIdError();
	}
	const { data: circle } = useQuery(circleQuery(circleId));

	useEffect(() => {
		if (circle) {
			const interestsList: Interest[] = [
				{
					displayName: 'To Do',
					value: 'todo',
					disabled: false,
					isChecked: circle.interests.includes('todo'),
				},
				{
					displayName: 'Expenses',
					value: 'expenses',
					disabled: false,
					isChecked: circle.interests.includes('expenses'),
				},
			];

			setInterests(interestsList);
		}
	}, [circle]);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = e.target.checked;
		const filteredInterests = interests.map(x => {
			if (x.value === e.target.value) {
				return { ...x, isChecked };
			}
			return x;
		});
		setInterests(filteredInterests);
	};

	useEffect(() => {
		if (isSuccess) {
			navigate(-1);
		}
		// eslint-disable-next-line
	}, [isSuccess]);

	const submitForm = (e: React.FormEvent<HTMLElement>) => {
		// We don't want the page to refresh
		e.preventDefault();
		if (interests.length && circleId) {
			const circleRequest: UpdateCircleRequest = {
				circleId,
				name: circle?.name,
				type: circle?.type,
				interests: interests.filter(x => x.isChecked).map(x => x.value),
			};
			updateCircle(circleRequest);
		} else {
			throw new Error('A form with blank name, type, or interest was submitted');
		}
	};

	return (
		<div>
			<Header title="Modules" subtitle="Select the modules you want to enable for your circle." />

			<Content>
				<form onSubmit={submitForm}>
					{interests.map(interest => {
						return (
							<div
								key={interest.value}
								style={{
									display: 'flex',
									flexDirection: 'row',
								}}>
								<EssenceAnimatedCheckbox
									checked={interest.isChecked}
									title={interest.displayName}
									name="interest-checkbox-group"
									value={interest.value}
									disabled={interest.disabled}
									key={interest.value}
									onChange={onChange}
								/>
							</div>
						);
					})}
					<div className="mb-16" />
					<EssenceButton type="submit" name="save" />
				</form>
			</Content>
		</div>
	);
}
